import { finalize } from 'rxjs/operators';
import {
  AfterContentInit,
  Component,
  Input
} from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { UIService } from '../../ui.service';
import { ActivatedRoute, Router } from '@angular/router';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../user.service';
import { ProfileService } from '../../../services/profile.services';
import { Configuration } from '../../conf/app.constants';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { DialogService } from 'primeng-lts/dynamicdialog';
import { OnDestroy } from '@angular/core';
import { AppConfiguration } from '../../conf/app.configuration';
import { Color } from 'chart.js';


@Component({
  selector: 'dossierContractsProgressGraph',
  templateUrl: 'dossierContractsProgressGraph.template.html'
})
export class DossierContractsProgressGraphComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  @Input()
  public dossier: any;

  loaded = false;
  graphicLoaded = false;

  chartTopType = 'doughnut';
  chartTopLabels: string[];
  chartTopData: any[];
  chartColors: Array<Color> = [];
  totalProgress: string;
  chartOptions: any;
  loadedProgressData: Array<any>;
  chartShowDivision = false;
  divisionId: string;
  divisions: string[];
  filteredData: any[];

  constructor(
    public uiService: UIService,
    public plycaService: PlycaDataService,
    protected route: ActivatedRoute,
    protected waitService: WaitLoadingService,
    public dialogService: DialogService,
    public translate: TranslateService,
    public configuration: Configuration,
    public profileService: ProfileService,
    protected router: Router,
    public userService: UserService,
    private appConfig: AppConfiguration
  ) {
    super();
  }

  ngAfterContentInit(): void {
    console.log('cargando grafico');
    this.chartOptions = Object.assign({}, this.uiService.pChartOptions);
    if (!this.chartOptions.tooltips) {
      this.chartOptions.tooltips = { enabled: false };
    } else {
      this.chartOptions.tooltips.enabled = false;
    }

    this.dossier['PROC_LETTERS'] = '';
    if (
      this.dossier &&
      this.dossier.division &&
      this.dossier.division.procedure
    ) {
      this.dossier['PROC_LETTERS'] = this.calculateLetters(
        this.dossier.division.procedure.description
      );
    }
    this.loadGraphicData();
    this.loaded = true;
    console.log('Grafico cargado');
  }

  processChartData(divisionId?: string): void {
    let labels: string[] = [];
    let dataList: any[] = [];
    let data0: any = { data: [] };
    this.divisions = [];

    this.chartShowDivision = false;
    if (divisionId) {
      this.chartShowDivision = true;
    }

    let sum = 0;
    let count = 0;
    for (let dato of this.loadedProgressData) {
      if (!divisionId || dato.columns.DIVISION.value === divisionId) {
        labels.push(dato.columns.DESCRIPCION.value);
        dataList.push(dato.columns);
        let value: number = Number(dato.columns.PORCEN_PLAZO_EJEC.value);
        this.divisions.push(dato.columns.DIVISION.value);
        data0.data.push(value);
        sum += value;
        count += 1;
      }
    }
    this.totalProgress = Math.round(sum / count) + '%';
    this.chartTopLabels = labels;




    // this.chartTopData = data;

    this.chartTopData = [];
    this.chartTopData['datasets'] = [];
    // this.chartTopData['labels'] = labels;

    let dataElement = {
      // El color de los puntos
      borderColor: Object.assign([],this.uiService.borderColor),
      // El color de las líneas
      backgroundColor: Object.assign([],this.uiService.backgroundColor),
      fill: true,
      borderWith: 1,
      legend: {
        display: false,
      },
      // options: this.uiService.pChartOptions,
    };
    if (sum < (100 * count)) {
      data0.data.push((100 * count) - sum);
      dataElement.backgroundColor[data0.data.length - 1] =
        'rgba(0,0,0,0)';
      dataElement.borderColor[data0.data.length - 1] =
      'rgba(240,240,240)';
    }
    dataElement['data'] = data0['data'];

    this.chartTopData['datasets'].push(dataElement);

    this.chartOptions = this.uiService.barChartOptions;


    this.filteredData = dataList;
    this.graphicLoaded = labels.length > 0;
  }

  isGraphicLoaded() {
    return this.graphicLoaded;
  }

  chartClicked(e: any): void {
    let val = -1;
    if (e) {
      val = e.element.index;
    }
    if (!this.chartShowDivision) {
      let division: string = this.divisions[val];
      this.processChartData(division);
    }
  }

  loadGraphicData(): void {
    this.subscribe(this.plycaService
      .getAttributeValue(
        'PROGRESO_CONTRATO_STD',
        'PROPUESTAID=' + this.dossier.identifier
      ).pipe(finalize(() => { this.waitService.cancelWaiting() })),
      x => {
        if (x.values) {
          this.loadedProgressData = x.values;
          this.processChartData();
        }
      },
      err => {
        console.log('Error cargando datos atributo: PROGRESO_CONTRATO_STD');
        console.log(err);
      }
    );
  }

  calculateLetters(originalText: string): string {
    let txt = '';
    if (originalText) {
      let words: string[] = originalText.split(' ');
      for (let entry of words) {
        txt = txt + entry.slice(0, 1).toUpperCase();
      }
    }
    return txt;
  }

  isLoaded(): boolean {
    return this.loaded;
  }

  isChartShowDivision(): boolean {
    return this.chartShowDivision;
  }
}
